var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcareAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_47588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.13401 4.13401 0 8 0H42C45.866 0 49 3.13401 49 7V41C49 44.866 45.866 48 42 48H8C4.13401 48 1 44.866 1 41V7Z",
    fill: "#FEF2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 32C16.45 32 15.9792 31.8042 15.5875 31.4125C15.1958 31.0208 15 30.55 15 30V25H20.375L22.1 28.45C22.1833 28.6333 22.3083 28.7708 22.475 28.8625C22.6417 28.9542 22.8167 29 23 29C23.1833 29 23.3583 28.9542 23.525 28.8625C23.6917 28.7708 23.8167 28.6333 23.9 28.45L27 22.25L28.1 24.45C28.1833 24.6333 28.3083 24.7708 28.475 24.8625C28.6417 24.9542 28.8167 25 29 25H35V30C35 30.55 34.8042 31.0208 34.4125 31.4125C34.0208 31.8042 33.55 32 33 32H17ZM15 23V18C15 17.45 15.1958 16.9792 15.5875 16.5875C15.9792 16.1958 16.45 16 17 16H33C33.55 16 34.0208 16.1958 34.4125 16.5875C34.8042 16.9792 35 17.45 35 18V23H29.625L27.9 19.55C27.8167 19.3667 27.6917 19.2375 27.525 19.1625C27.3583 19.0875 27.1833 19.05 27 19.05C26.8167 19.05 26.6417 19.0875 26.475 19.1625C26.3083 19.2375 26.1833 19.3667 26.1 19.55L23 25.75L21.9 23.55C21.8167 23.3667 21.6917 23.2292 21.525 23.1375C21.3583 23.0458 21.1833 23 21 23H15Z",
    fill: "#F6B804"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_47588",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_47588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_47588",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcareAnalytics);
export default __webpack_public_path__ + "static/media/healthcare-analytics.686e2f99ea9c687f29b98b87b3fcedf4.svg";
export { ForwardRef as ReactComponent };